import { loading, success, error } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';

import * as types from './types';
/**
 * Retrieves default templates
 */
export const getTemplates = () => async (dispatch, getState, MPWWebApi) => {
  dispatch(loading(types.LETTER_TEMPLATES_FETCHING, true));
  try {
    const response = await MPWWebApi.getGeneric('Letter/GetAllTemplates');
    const templates = response.data.Data;
    dispatch(success(types.LETTER_TEMPLATES_FETCH, templates));
  } catch (err) {
    dispatch(error(types.LETTER_TEMPLATES_FETCH_ERROR, err));
  }
  dispatch(loading(types.LETTER_TEMPLATES_FETCHING, false));
};
/**
 *
 * @param {Number} LetterTemplateId
 * @param {String} Body
 * @param {[Number]} Sites
 * @param {Number} Margin
 */
export const writeCustomLetter = (
  LetterTemplateId,
  Body,
  Sites,
  Margin,
  IsLegal
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.LETTER_WRITE_CUSTOM_LETTER_FETCHING, true));
    try {
      const data = {
        Body,
        LetterTemplateId,
        Sites,
        Margin,
        IsLegal,
      };
      await MPWWebApi.postGenericInsertUpdate('Letter/WriteCustomLetter', data);
      createToast(
        toastType.success,
        'Success',
        'Letter template successfully updated',
        true
      );
      success(types.LETTER_WRITE_CUSTOM_LETTER);
    } catch (err) {
      dispatch(error(types.LETTER_WRITE_CUSTOM_LETTER_ERROR, err));
    }
    dispatch(loading(types.LETTER_WRITE_CUSTOM_LETTER_FETCHING, false));
  };
};

/**
 *
 * @param {String} LetterHTML - HTML String
 * @param {Number} LetterMargin - Margin Number
 */
export const getPreview = (LetterHTML, LetterMargin, IsLegal) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  dispatch(loading(types.LETTER_PREVIEW_FETCHING, true));
  try {
    const response = await MPWWebApi.postGenericInsertUpdate(
      `Letter/LetterPreview`,
      {
        LetterHTML,
        LetterMargin,
        IsLegal,
      }
    );
    const previewPdf = response.data.Data;
    dispatch(success(types.LETTER_PREVIEW_FETCH, previewPdf));
  } catch (err) {
    dispatch(error(types.LETTER_PREVIEW_FETCH_ERROR, err));
  }
  dispatch(loading(types.LETTER_PREVIEW_FETCHING, false));
};

export const clearPreview = () => ({
  type: types.LETTER_PREVIEW_CLEAR,
});



// WEBPACK FOOTER //
// ./src/pages/lettersetup/state/setup/actions.js